import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Authorization } from '../../model/authorization';
import { AuthRoles_PTBR } from '../../model/AuthRoles';
import { DataNavigation } from '../../util/dataNavigation';

@Component({
  selector: 'auth-compare',
  templateUrl: './auth-compare.component.html',
  styleUrls: ['./auth-compare.component.css']
})
export class AuthCompareComponent implements OnInit {

  constructor(
    protected router: Router, 
    private dataNavigation: DataNavigation) { }

  ngOnInit(): void {
  }

  translate(role: string) {
    return AuthRoles_PTBR.hasOwnProperty(role) ? AuthRoles_PTBR[role] : role;
  }

  authClicked(modalRef, auth: Authorization) {
    modalRef.hide();
    this.dataNavigation.selectAuthorization(auth);
    this.router.navigate(['pages/register']);
  }
}
